import React, { useState, useEffect, useRef } from 'react';
import NormalTable from '../../../../utility/table/NormalTable.jsx';
import { useTranslation } from 'react-i18next';
import CommonComponent from "../../CommonComponent";
import SalesCard from './SalesCard';
import useDashboardHome from './useDashboardHome';
import usePersistentDateRange from '../../Common/usePersistentDateRange';
import { getFilterOptions } from '../../Common/getFilterOptions';
import SalesVsSpendChart from './ChartLayout/SalesVsSpendChart'
import TotalRevenueChart from './ChartLayout/TotalRevenueChart'
import PaymentDistributionChart from './ChartLayout/PaymentDistributionChart'
import NoDataFound from '../NoDataFound/NoDataFound'
import Spinner from '../NoDataFound/Spinner'
import DashboardReady from '../DashboardReady/DashboardReady'
import { useOption } from '../../../../context/OptionContext.js';

import KpiCard from './KpiCard.jsx';
import useThemeTextColor from '../../../../utils/useThemeTextColor.jsx';
import KpiCarousel from './KpiCard.jsx';
import KpiAccordion from './KpiCard.jsx';
import PremiumOverlayCard from "../../../../common/PremiumOverlayCard";
import { usePermissions } from "../../../../context/PermissionContext";
import PermissionControlledCard from '../../../../common/PermissionControlledCard.jsx';
import { add, sub } from '../../../../../images/index.js';
import { useStatus } from '../../../../context/StatusContext.js';
import formatDate from '../../../../common/DateFormate.js';



const DashboardHome = () => {
  const {
    loadingRevenue,
    loadingSpend,
    totalRevenue,
    spendAnlysis,
    revenueBussiness,
    getTotalRevenueSales,
    getSpendAnlysisRevenue,
    getBussinessRevenue,
    getTopSellingProducts,
    getTopSellingCategory,
    getDashboardSummaryCard,
    getSalesByState,
    SalesByState,
    topSellingProductsState,
    topSellingCategoryState,
    topSellingCategoryStateLoaded,
    totalRevenueFilter,
    spendAnlysisFilter,
    setTotalRevenueFilter,
    setSpendAnlysisFilter,
    paymentModeState,
    getPaymentMode, topSellingProductsStateLoaded, SalesByStateLoaded,
    loadingState,
    getDashboardKpiCategory,
    revenueBussinessCount,
    getBussinessRevenueCount
  } = useDashboardHome();

  const { t } = useTranslation();
  const permission = usePermissions();
  const { selectedOption } = useOption();
  const [isOpen, setIsOpen] = useState(true);
  const [isRevenueOpen, setIsRevenueOpen] = useState(true);
  const [isSalesByState, setIsSalesByState] = useState(true);
  const textColor = useThemeTextColor("--black-color");
  const borderColor = useThemeTextColor("--black-color");
const { statusValues } = useStatus();
const dashboardReady = statusValues.dashboardReady;
  const {
    selectedRange,
    handleDateChange,
    formattedStart,
    formattedEnd,
  } = usePersistentDateRange();

  const hasMountedRevenue = useRef(false);
  const hasMountedSpend = useRef(false);
  useEffect(() => {
    if (hasMountedRevenue.current) {
      if (totalRevenueFilter) {
        getTotalRevenueSales({ totalRevenueFilter, formattedEnd, formattedStart });
      }
    } else {
      hasMountedRevenue.current = true;
    }
  }, [totalRevenueFilter]);

  useEffect(() => {
    if (hasMountedSpend.current) {
      if (spendAnlysisFilter) {
        getSpendAnlysisRevenue({ spendAnlysisFilter, formattedEnd, formattedStart });
      }
    } else {
      hasMountedSpend.current = true;
    }
  }, [spendAnlysisFilter]);
  
  useEffect(() => {
    // Always run on initial mount or date change for general data
    if (formattedStart && formattedEnd) {
      getTotalRevenueSales({ totalRevenueFilter, formattedEnd, formattedStart });
      getSpendAnlysisRevenue({ spendAnlysisFilter, formattedEnd, formattedStart });
      getBussinessRevenue({ formattedEnd, formattedStart });
      getTopSellingProducts({ formattedEnd, formattedStart });
      getTopSellingCategory({ formattedEnd, formattedStart });
      getPaymentMode({ formattedEnd, formattedStart });
      getSalesByState({ formattedEnd, formattedStart });
      getBussinessRevenueCount({formattedEnd, formattedStart});
    }
  }, [formattedStart, formattedEnd, selectedOption?.id]);


  const SalesByStateEmpty = !SalesByState || Object.keys(SalesByState).length === 0;
  const topSellingProductsStateEmpty = !topSellingProductsState || Object.keys(topSellingProductsState).length === 0;
  
  const options = getFilterOptions(formattedStart, formattedEnd, "dashboard-home");
  const topSellingCategoryDownloadPermission  = permission?.data?.dashboard?.top_selling_category?.download_option?.allowed && permission?.data?.dashboard?.top_selling_category?.download_option?.display;
  const topSellingProductDownloadPermission  =  permission?.data?.dashboard?.top_selling_products?.download_option?.allowed && permission?.data?.dashboard?.top_selling_products?.download_option?.display;
  const salesByStateDownloadPermission  =  permission?.data?.dashboard?.sales_by_state?.download_option?.allowed && permission?.data?.dashboard?.top_selling_category?.download_option?.display;
  const settlementDate = "25 Feb 2026";
  const lastSettlementOrderDate = "24 Feb 2026";
  const settlementOrdersCount = 12;
  const message = "Next settlement will be processed within 2 working days.";

  return (
    <>
      <CommonComponent
        defaultRange={selectedRange}
        onRangeChange={handleDateChange}
      />

        <div className="card mt-2 shadow-sm">
          <div className="card-body">

            <div className="row">
              <div className="col">
                <h6 className="mb-1 kpi-name">Last Settlement Date</h6>
                <p className="kpi-sub-value">{formatDate(statusValues?.maxSettlementAt) || "—"}</p>
              </div>

              <div className="col">
                <h6 className="mb-1 kpi-name">Last Settle Order Purchase Date</h6>
                <p className="kpi-sub-value">{formatDate(statusValues?.maxPurchaseAt) || "—"}</p>
              </div>

            </div>

            {statusValues?.message && (
              <div className="mt-0 mb-0 p-0">
                <i className='bi bi-info text-primary border border-primary rounded-circle small'></i>{" "}
                <span className='small text-secondary'
                  dangerouslySetInnerHTML={{ __html: statusValues.message }}
                />
              </div>
            )}

          </div>
        </div>

      {!dashboardReady ? <DashboardReady /> :
        <section className="section dashboard py-2" id="dashboard-download">
          <div className="container-fluid">
            <div className="row m-0">
              <div>
               <SalesCard formattedStart={formattedStart} formattedEnd={formattedEnd} type={"parent"} permission={permission?.data?.dashboard?.kpi?.topline_growth}/>
              </div>


                {/* KPI Cards */}
                
                <div className={"col-12 kpi-section" + (permission?.data?.dashboard?.kpi?.growth_and_risk?.display && permission?.data?.dashboard?.kpi?.growth_and_risk?.allowed ? "" : "d-none")}>
                  <div className="row">
                    <div className="container">
                      {/* Collapsible content */}   
                        <SalesCard formattedStart={formattedStart} formattedEnd={formattedEnd} type={"child"} permission={permission?.data?.dashboard?.kpi?.growth_and_risk}/>
                    </div>
                  </div>
                </div>
                {/* Total Revenue */}
                <div className='col-12 flex-wrap g-2 graph-section'>
                      <div className={`col-12 d-flex justify-content-between align-items-center ${isRevenueOpen ? "mb-3" : ""}`}>
                        <h5 className="mb-0 kpi-heading">Sales & Trends</h5>
                        <div className="collapse-btn" // text matches border  background: "transparent" // keep outline style
                           onClick={() => setIsRevenueOpen(!isRevenueOpen)} aria-expanded={isRevenueOpen} aria-controls="kpiCollapse" >
                          <img src={isRevenueOpen ? sub : add} alt="Toggle" style={{ width: "24px", height: "24px", marginLeft: "5px", filter: `invert(${textColor === '#ffffff' ? 1 : 0})` }} />
                        </div>
                      </div>
                      <div className={`row col-lg-12 collapse ${isRevenueOpen ? "show mt-2" : ""}`} id="kpiCollapse">
                      <PermissionControlledCard permission={permission?.data?.dashboard?.bar_graphs?.sales} colClass="col-12 col-md-8 col-lg-8">
                      <div className="col-12">

                        <div className="card total-revenue">
                          <div className="card-body card-height">
                            <div className="d-flex justify-content-between align-items-center ">
                              <h5 className="kpi-sub-heading">
                                {t("dashboardHome.totalRevenue")}
                              </h5>
                              <div className="d-flex justify-content-end">
                                <select
                                  className="form-select w-auto select-day graph-filter kpi-name"
                                  value={totalRevenueFilter}
                                  onChange={e => {
                                    e.preventDefault();
                                    setTotalRevenueFilter(e.target.value);
                                  }}
                                >
                                  {options.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="chart-container">
                              {loadingRevenue ? (
                                <Spinner height={300} />
                              ) : (
                                <TotalRevenueChart chartData={totalRevenue} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      </PermissionControlledCard>



                    {/* Sales vs Spend */}
                    {/*<div className="col-12 col-md-12 col-lg-6">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="kpi-heading">
                              {t("dashboardHome.salesVsSpendAnalysis")}
                            </h5>
                            <div className="d-flex justify-content-end">
                              <select
                                className="form-select w-auto select-day graph-filter"
                                value={spendAnlysisFilter}
                                onChange={e => {
                                  e.preventDefault();
                                  setSpendAnlysisFilter(e.target.value);
                                }}
                              >
                              {options.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                              </select>
                            </div>
                          </div>
                          <div className="chart-container">
                            {loadingSpend ? (
                              <Spinner height={300} />
                            ) : (
                            <SalesVsSpendChart chartData={spendAnlysis} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>*/}


                    {/* Business Revenue Pie Chart Count */}
                    <PermissionControlledCard permission={permission?.data?.dashboard?.pie_graphs?.units_share} colClass='col-12 col-md-4 col-lg-4 ps-lg-0 pe-lg-0'>
                    <div className="col">

                      <div className="card total-revenue">
                        <div className="card-body d-flex flex-column card-height">
                          <h5 className="kpi-sub-heading mb-3">{t("dashboardHome.bussinessGross")}</h5>
                          <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                            {/* Limit height and maintain responsiveness */}
                            <div style={{ width: "100%",height: "auto" }}>
                              {loadingState?.revenueBussinessCount ? (
                                <Spinner type="pie" height={300} />
                              ) : (
                                <PaymentDistributionChart chartData={revenueBussinessCount} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    </PermissionControlledCard>

                    {/* </div> */}
                      </div>
                </div>
              <div className='col-12 flex-wrap g-2 graph-section'>
                <div className={`col-12 d-flex justify-content-between align-items-center ${isSalesByState ? "mb-3" : ""}`}>
                  <h5 className="mb-0 kpi-heading">Business Growth Metrics</h5>
                  {/* <button className="btn btn-sm collapse-btn" style={{ borderColor, color: borderColor,  background: "transparent"  // text matches border  background: "transparent" // keep outline style
                    }} onClick={() => setIsSalesByState(!isSalesByState)} aria-expanded={isSalesByState} aria-controls="salesByStateCollapse" >
                    <i className={`bi ${isSalesByState ? "bi-dash" : "bi-plus"}`}></i>
                  </button> */}
                  <div className="collapse-btn" // text matches border  background: "transparent" // keep outline style
                           onClick={() => setIsSalesByState(!isSalesByState)} aria-expanded={isSalesByState} aria-controls="kpiCollapse" >
                    <img src={isSalesByState ? sub : add} alt="Toggle" style={{ width: "24px", height: "24px", marginLeft: "5px", filter: `invert(${textColor === '#ffffff' ? 1 : 0})` }} />
                  </div>
                </div>
              <div className={`row col-lg-12 collapse ${isSalesByState ? "show mt-2" : ""}`} id="salesByStateCollapse">
              {/* Business Revenue Pie Chart */}

              <PermissionControlledCard permission={permission?.data?.dashboard?.pie_graphs?.b2b_vs_b2c} colClass='col-12 col-md-4 col-lg-4'>
              {/* <div className="col"> */}
                  <div className="card">
                    <div className="card-body d-flex flex-column card-height">
                      <h5 className="kpi-sub-heading mb-3">{t("dashboardHome.bussinessRevenue")}</h5>
                      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                        {/* Limit height and maintain responsiveness */}
                        <div style={{ width: "100%", maxWidth: "300px", height: "auto" }}>
                          {loadingState?.revenueBussiness ? (
                            <Spinner type="pie" height={300} />
                          ) : (
                            <PaymentDistributionChart chartData={revenueBussiness} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
              {/* </div> */}
              </PermissionControlledCard>


              {/* Sales by State */}
              <PermissionControlledCard permission={permission?.data?.dashboard?.bar_graphs?.sales} colClass='col-12 col-md-8 col-lg-8 pe-lg-0 ps-lg-0 pe-lg-0'>
              {/* <div className="col"> */}
                <div className="card">
                  <div className="card-body  card-height">
                    <h5 className="kpi-sub-heading mb-3">{t("dashboardHome.salesByState")}</h5>
                    <div className="table-responsive">
                      {
                        SalesByStateLoaded && Array.isArray(SalesByState) && SalesByState.length === 0 ? (
                          <div style={{ textAlign: "center", padding: "30px", fontWeight: "500" }} className='w-100 no-data-found'>
                            No data found for the given criteria.
                          </div>
                        ) : (
                          <NormalTable downloadBtnPermission={salesByStateDownloadPermission} tableId="salesByState" defaultPageLength={5} data={SalesByState} enableSelection={false} loading={loadingState?.salesByState} />)}
                    </div>
                  </div>
                </div>
              {/* </div> */}
              </PermissionControlledCard>
              </div>
              </div>

              {/* Top Selling Category */}
              <PermissionControlledCard  permission={permission?.data?.dashboard?.top_selling_category?.table_view} colClass='col-12 col-md-6 col-lg-6 ps-0 pe-2 selling-category'>
              <div className="col mt-2">
                <div className="card">
                  <div className="card-body card-height">
                    <div className='d-flex justify-content-between align-items-center'>
                    <h5 className="kpi-heading mb-3 px-1">{t("dashboardHome.topSellingCategory")}</h5>
                      {/* <button className="btn btn-sm" style={{ borderColor, color: borderColor,  background: "transparent"  // text matches border  background: "transparent" // keep outline style
                      }} onClick={() => setIsRevenueOpen(!isRevenueOpen)} aria-expanded={isRevenueOpen} aria-controls="kpiCollapse" >
                      <i className={`bi ${isRevenueOpen ? "bi-dash" : "bi-plus"}`}></i>
                    </button> */}
                    </div>
                    <div className="table-responsive">
                      {
                        topSellingCategoryStateLoaded && Array.isArray(topSellingCategoryState) && topSellingCategoryState.length === 0 ? (
                          <div style={{ textAlign: "center", padding: "30px", fontWeight: "500" }} className='w-100 no-data-found'>
                            No data found for the given criteria.
                          </div>
                        ) : (
                          <NormalTable downloadBtnPermission={topSellingCategoryDownloadPermission} tableId="topSellingCategory" defaultPageLength={5} data={topSellingCategoryState && topSellingCategoryState} enableSelection={false} loading={loadingState?.topSellingCategoryState} />
                        )}
                    </div>
                  </div>
                </div>
              </div>
              </PermissionControlledCard>

              {/* Top Selling Products */}
              <PermissionControlledCard permission={permission?.data?.dashboard?.top_selling_products?.table_view} colClass='col-12 col-md-6 col-lg-6 ps-0 pe-0'>
              <div className="col m-0 p-0 mt-2">
                <div className="card">
                  <div className="card-body  card-height">
                    <div className='d-flex justify-content-between align-items-center'>
                    <h5 className="kpi-heading mb-3 px-1">{t("dashboardHome.topSellingProducts")}</h5>
                    {/* <button className="btn btn-sm" style={{ borderColor, color: borderColor,  background: "transparent"  // text matches border  background: "transparent" // keep outline style
                      }} onClick={() => setIsRevenueOpen(!isRevenueOpen)} aria-expanded={isRevenueOpen} aria-controls="kpiCollapse" >
                      <i className={`bi ${isRevenueOpen ? "bi-dash" : "bi-plus"}`}></i>
                    </button> */}
                    </div>
                    <div className="table-responsive">
                      {
                        topSellingProductsStateLoaded && Array.isArray(topSellingProductsState) && topSellingProductsState.length === 0 ? (
                          <div style={{ textAlign: "center", padding: "30px", fontWeight: "500" }} className='w-100 no-data-found'>
                            No data found for the given criteria.
                          </div>
                        ) : (
                          <NormalTable downloadBtnPermission={topSellingProductDownloadPermission} tableId="topSellingProducts" defaultPageLength={5} data={topSellingProductsState && topSellingProductsState} enableSelection={false} loading={loadingState?.topSellingProductsState} />
                        )}
                    </div>
                  </div>
                </div>
              </div>
              </PermissionControlledCard>

              {/* <div className="col-12 col-md-6">
                <div className="card">
                  <div className="card-body d-flex flex-column">
                    <h5 className="kpi-heading mb-3">{t("dashboardHome.paymentMode")}</h5>
                    <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                      <div style={{ width: "100%", maxWidth: "300px", height: "auto" }}>
                        {loadingState?.paymentModeState ? (
                          <Spinner type="pie" height={300} />
                        ) : (
                          <PaymentDistributionChart chartData={paymentModeState} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

            </div>
          </div>
        </section>
      }
    </>
  );
};

export default DashboardHome;
